var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-home" },
    [
      _c(
        "v-row",
        { staticClass: "my-0" },
        [
          _c("v-col", { staticClass: "py-0", attrs: { cols: "12" } }, [
            _c("h2", { staticClass: "mb-3" }, [
              _vm._v(
                "Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR"
              )
            ]),
            _c("div", { staticClass: "notice-box" }, [
              _vm._v(
                "Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind."
              )
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Willkommen auf dem Antragsportal der Gesellschaft zur Verwertung von Leistungsschutzrechten (GVL)."
              )
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Die Corona-Krise hat vielen Künstlern* die Möglichkeiten genommen, in ihrem Berufsfeld Geld zu verdienen: Theater, Kinos und Konzerthallen sind seit mehr als einem Jahr geschlossen. Musik-, Fernseh- und Filmproduktionen können nur stark eingeschränkt stattfinden. Die Bundesbeauftragte für Kultur und Medien hat im Auftrag der Bundesregierung das Programm NEUSTART KULTUR aufgelegt, um die Kulturschaffenden im Land zu unterstützen. Das Stipendienprogramm der Verwertungsgesellschaften fördert in diesem Herbst künstlerische Maßnahmen über einen Zeitraum von vier Monaten."
              )
            ]),
            _c("p", { staticClass: "mt-4 mb-2" }, [
              _c("i", [_vm._v("5000 Euro für künstlerische Maßnahmen")])
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Die GVL verteilt die Förderung an freiberufliche oder auf Produktionsdauer beschäftigte Künstler. Der Gesamtumfang beträgt 30 Mio. EUR. Ab August können sich Künstler bei der GVL für ein Stipendium von 5.000 EUR bewerben."
              )
            ]),
            _c("p", { staticClass: "mt-4 mb-2" }, [
              _c("i", [_vm._v("Antragstellung")])
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Das Stipendienprogramm richtet sich an freiberufliche Künstler, die überwiegend von ihren Einnahmen aus künstlerischer Tätigkeit leben und die durch die Corona-Krise in eine existentielle Notlage geraten sind."
              )
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Anträge können auf dieser Website online eingereicht werden. Die Stipendien werden in der Reihenfolge der Antragstellung vergeben. Über die Stipendienvergabe entscheidet eine unabhängige Fachjury."
              )
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Die Antragssteller müssen keine Berechtigten der GVL sein, da die künstlerische Tätigkeit auch anderweitig nachgewiesen werden kann."
              )
            ]),
            _c("p", { staticClass: "mt-4 mb-2" }, [
              _c("i", [_vm._v("Geförderte Maßnahmen")])
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Gefördert werden künstlerische Projekte wie Darbietungen, Produktionen oder Online-Formate. Die Projekte können sich noch im Entwicklungsstadium befinden, es kann sich um Kooperationen oder um Rechercheprojekte für künftige Produktionen handeln. Das Stipendium unterstützt auch Künstler, die sich neue Techniken und Arbeitsweisen im Rahmen einer Fortbildung aneignen möchten, wenn diese für die Umsetzung eines Entwicklungsvorhabens erforderlich sind."
              )
            ]),
            _c("p", { staticClass: "mt-4 mb-2" }, [
              _c("i", [_vm._v("Details in den FAQ")])
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                "Nähere Informationen zur Antragstellung, zum Förderverfahren und zur Abrechnung der Förderung finden Sie in den FAQ. Bitte lesen Sie die Informationen gründlich durch, bevor Sie Ihren Antrag stellen."
              )
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _c("b", [
                _vm._v(
                  "Bei weiteren Fragen wenden Sie sich Montag bis Sonntag von 6:00 bis 22:00 Uhr an unsere Hotline unter der Nummer 0202-2515 57305."
                )
              ])
            ]),
            _c("p", { staticClass: "mt-4 mb-2" }, [
              _c("i", [_vm._v("Informationen zu NEUSTART KULTUR")])
            ]),
            _c("p", [
              _vm._v(
                "Weitere Informationen der Bundesregierung zu NEUSTART KULTUR finden Sie hier: "
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien/corona-hilfen",
                    target: "blank"
                  }
                },
                [_vm._v("www.kulturstaatsministerin.de/neustartkultur")]
              )
            ]),
            _c("p", { staticClass: "small-text mt-6 mb-2" }, [
              _c("sup", [_vm._v("*")]),
              _vm._v(
                "Aufgrund der besseren Lesbarkeit wird im Text das generische Maskulinum verwendet. Gemeint sind jedoch immer alle Geschlechter (m/w/d)."
              )
            ]),
            _c("p", { staticClass: "small-text" }, [
              _vm._v(
                "Die Verteilung der Fördergelder für die anderen Kultur- und Medienbereiche übernehmen verschiedene Organisationen."
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }